
// Statü değerleri
export const statusEnumArray = [
  'NeedsReview',
  'Updated',
  'Approved'
];

export const getStatusLabel = (status: number | string | undefined): string => {
  if (status === undefined) return 'Needs Review';
  
  // String değerler için
  if (typeof status === 'string') {
    switch (status) {
      case 'NeedsReview':
        return 'Needs Review';
      case 'Updated':
        return 'Updated';
      case 'Approved':
        return 'Approved';
      default:
        return 'Needs Review';
    }
  }
  
  // Number değerler için (eski uyumluluk)
  switch (Number(status)) {
    case 0:
      return 'Needs Review';
    case 1:
      return 'Updated';
    case 2:
      return 'Approved';
    default:
      return 'Needs Review';
  }
};

export const getStatusColor = (status: number | string | undefined): string => {
  if (status === undefined) return "#FFCA1C"; // Needs Review
  
  if (typeof status === 'string') {
    switch (status) {
      case 'NeedsReview':
        return "#FFCA1C";
      case 'Updated':
        return "#9B86BC";
      case 'Approved':
        return "#7EC4C0";
      default:
        return "#FFCA1C";
    }
  }
  
  switch (Number(status)) {
    case 0:
      return "#FFCA1C"; // Needs Review
    case 1:
      return "#9B86BC"; // Updated
    case 2:
      return "#7EC4C0"; // Approved
    default:
      return "#FFCA1C";
  }
}; 